import type {HovercardAttributesResult} from '@github-ui/hovercards/use-get-hovercard-attributes-for-type'
import {ProfileReference} from '@github-ui/profile-reference'
import type {RelayCompat} from '@github-ui/server-persisted-queries/relay-compat'
import type {IssueViewerViewQueryQuery} from '@github-ui/server-persisted-queries/types/IssueViewerViewQuery'
import {Link} from '@primer/react'
import {clsx} from 'clsx'

import {VALUES} from '../constants/values'
import styles from './IssueBodyHeaderAuthor.module.css'

type IssueViewerIssue = NonNullable<NonNullable<IssueViewerViewQueryQuery['repository']>['issue']>
type IssueViewerAuthor = NonNullable<IssueViewerIssue['author']>
type IssueViewerNamedAuthor = Extract<
  IssueViewerAuthor,
  {readonly __typename: 'User' | 'EnterpriseUserAccount' | 'Mannequin'}
>

// RELAY-CLEANUP(IssueBodyHeader): widens nullable fields so the still-Relay parent
// data is assignable. Remove when IssueBodyHeader leaves Relay.
export type IssueBodyHeaderAuthorFragment = RelayCompat<
  Pick<IssueViewerAuthor, 'login' | 'profileUrl' | '__typename'> & {
    readonly name?: IssueViewerNamedAuthor['name']
    readonly isCopilot?: boolean
  }
>

export function getIssueAuthorDisplayName(
  author: IssueBodyHeaderAuthorFragment | null | undefined,
): string | undefined {
  return author?.__typename === 'Bot' && author.isCopilot ? 'Copilot' : undefined
}

export function IssueBodyHeaderAuthor({
  author,
  authorHovercardAttrs,
}: {
  author: IssueBodyHeaderAuthorFragment | null
  authorHovercardAttrs?: HovercardAttributesResult
}) {
  const {login, name, profileUrl} = author || VALUES.ghost
  const displayName = getIssueAuthorDisplayName(author)

  return (
    <Link
      href={profileUrl || undefined}
      {...authorHovercardAttrs}
      data-testid="issue-body-header-author"
      className={clsx(styles.authorLoginLink, !profileUrl && styles.noProfileLink)}
    >
      {displayName ?? <ProfileReference login={login} profileName={name} isAgent={false} />}
    </Link>
  )
}
